export const TBL_AI_FEEDBACK_TABLE = [
    {
        "CATEGORY": 0,
        "MESSAGE_ID": "F0001",
        "MESSAGE_TEXT": "$님, 오늘은 랜덤 운동으로 시작해봐요. 디딤 체력측정을 하면 더 정확한 추천을 받을 수 있습니다.",
        "INTENSITY": "LOW",
        "CONDITION": "데이터 없음"
    },
    {
        "CATEGORY": 0,
        "MESSAGE_ID": "F0002",
        "MESSAGE_TEXT": "$님, 지금은 기본 루틴으로 몸을 풀어봐요. 디딤 체력측정을 하면 개인 맞춤 운동을 추천받을 수 있어요.",
        "INTENSITY": "LOW",
        "CONDITION": "데이터 없음"
    },
    {
        "CATEGORY": 0,
        "MESSAGE_ID": "F0003",
        "MESSAGE_TEXT": "$님, 오늘은 랜덤 루틴으로 몸을 움직여볼까요? 체력측정을 하면 나만의 운동 패턴이 만들어집니다.",
        "INTENSITY": "MID",
        "CONDITION": "데이터 없음"
    },
    {
        "CATEGORY": 0,
        "MESSAGE_ID": "F0004",
        "MESSAGE_TEXT": "$님, 아직 개인 데이터가 없네요. 디딤 체력측정으로 정확한 운동 레벨을 확인해보세요.",
        "INTENSITY": "LOW",
        "CONDITION": "데이터 없음"
    },
    {
        "CATEGORY": 0,
        "MESSAGE_ID": "F0005",
        "MESSAGE_TEXT": "$님, 오늘은 AI가 준비한 랜덤 루틴이에요. 체력측정을 하면 더 정밀한 운동 추천이 가능해요.",
        "INTENSITY": "MID",
        "CONDITION": "데이터 없음"
    },
    {
        "CATEGORY": 0,
        "MESSAGE_ID": "F0006",
        "MESSAGE_TEXT": "$님, 랜덤 루틴으로 시작해요. 체력측정을 하면 $님만을 위한 맞춤 루틴을 드릴게요.",
        "INTENSITY": "LOW",
        "CONDITION": "데이터 없음"
    },
    {
        "CATEGORY": 0,
        "MESSAGE_ID": "F0007",
        "MESSAGE_TEXT": "$님, 오늘은 가볍게 랜덤 운동으로 시작해요. 체력측정을 하면 개인화된 운동을 추천받을 수 있습니다.",
        "INTENSITY": "MID",
        "CONDITION": "데이터 없음"
    },
    {
        "CATEGORY": 0,
        "MESSAGE_ID": "F0008",
        "MESSAGE_TEXT": "$님, 아직 체력측정 기록이 없네요. 디딤에서 측정하면 맞춤 운동을 추천해드려요.",
        "INTENSITY": "LOW",
        "CONDITION": "데이터 없음"
    },
    {
        "CATEGORY": 0,
        "MESSAGE_ID": "F0009",
        "MESSAGE_TEXT": "$님, 지금은 랜덤 운동으로 체험해보세요. 체력측정을 하면 더 정확한 루틴을 제공합니다.",
        "INTENSITY": "MID",
        "CONDITION": "데이터 없음"
    },
    {
        "CATEGORY": 0,
        "MESSAGE_ID": "F0010",
        "MESSAGE_TEXT": "$님, 디딤 체력측정을 통해 나만의 운동 데이터를 만들어보세요. 이후엔 개인 맞춤 운동이 추천됩니다.",
        "INTENSITY": "NONE",
        "CONDITION": "데이터 없음"
    },
    {
        "CATEGORY": 1.1,
        "MESSAGE_ID": "F1101",
        "MESSAGE_TEXT": "$님, 어제는 #보로 활동량이 조금 적었어요.",
        "INTENSITY": "LOW",
        "CONDITION": "걸음수 < 5,000",
        "": "사용자 이름"
    },
    {
        "CATEGORY": 1.1,
        "MESSAGE_ID": "F1102",
        "MESSAGE_TEXT": "$님, 어제는 #보로 평소보다 덜 걸으셨어요. 오늘은 조금만 더 움직여볼까요?",
        "INTENSITY": "LOW",
        "CONDITION": "걸음수 < 5,000",
        "": "전날 걸음수"
    },
    {
        "CATEGORY": 1.1,
        "MESSAGE_ID": "F1103",
        "MESSAGE_TEXT": "$님, 어제는 #보로 몸이 휴식한 하루였어요.",
        "INTENSITY": "LOW",
        "CONDITION": "걸음수 < 5,000",
        "": "평균 심박수"
    },
    {
        "CATEGORY": 1.1,
        "MESSAGE_ID": "F1104",
        "MESSAGE_TEXT": "$님, 어제는 #보로 무리하지 않은 하루였어요.",
        "INTENSITY": "LOW",
        "CONDITION": "걸음수 < 5,000"
    },
    {
        "CATEGORY": 1.1,
        "MESSAGE_ID": "F1105",
        "MESSAGE_TEXT": "$님, 어제는 #보로 조용한 하루를 보냈어요. 오늘은 몸의 리듬을 되찾아봐요.",
        "INTENSITY": "LOW",
        "CONDITION": "걸음수 < 5,000"
    },
    {
        "CATEGORY": 1.1,
        "MESSAGE_ID": "F1106",
        "MESSAGE_TEXT": "$님, 어제는 #보로 잠깐 쉬어간 하루였어요.",
        "INTENSITY": "LOW",
        "CONDITION": "걸음수 < 5,000"
    },
    {
        "CATEGORY": 1.1,
        "MESSAGE_ID": "F1107",
        "MESSAGE_TEXT": "$님, 어제는 #보로 컨디션 회복에 집중한 하루였네요.",
        "INTENSITY": "LOW",
        "CONDITION": "걸음수 < 5,000"
    },
    {
        "CATEGORY": 1.1,
        "MESSAGE_ID": "F1108",
        "MESSAGE_TEXT": "$님, 어제는 #보로 활동량이 낮았어요. 오늘은 조금 더 걸어볼까요?",
        "INTENSITY": "LOW",
        "CONDITION": "걸음수 < 5,000"
    },
    {
        "CATEGORY": 1.1,
        "MESSAGE_ID": "F1109",
        "MESSAGE_TEXT": "$님, 어제는 #보로 몸이 가벼웠죠? 오늘은 리듬을 다시 올려봐요.",
        "INTENSITY": "LOW",
        "CONDITION": "걸음수 < 5,000"
    },
    {
        "CATEGORY": 1.1,
        "MESSAGE_ID": "F1110",
        "MESSAGE_TEXT": "$님, 어제는 #보로 에너지를 비축한 하루였어요.",
        "INTENSITY": "LOW",
        "CONDITION": "걸음수 < 5,000"
    },
    {
        "CATEGORY": 1.2,
        "MESSAGE_ID": "F1201",
        "MESSAGE_TEXT": "$님, 어제는 #보로 안정적인 하루를 보내셨어요.",
        "INTENSITY": "MID",
        "CONDITION": "5,000 ≤ 걸음수 < 9,000"
    },
    {
        "CATEGORY": 1.2,
        "MESSAGE_ID": "F1202",
        "MESSAGE_TEXT": "$님, 어제는 #보로 꾸준한 리듬을 유지하셨어요. 좋아요!",
        "INTENSITY": "MID",
        "CONDITION": "5,000 ≤ 걸음수 < 9,000"
    },
    {
        "CATEGORY": 1.2,
        "MESSAGE_ID": "F1203",
        "MESSAGE_TEXT": "$님, 어제는 #보로 좋은 흐름이었어요. 지금처럼만 가볼까요?",
        "INTENSITY": "MID",
        "CONDITION": "5,000 ≤ 걸음수 < 9,000"
    },
    {
        "CATEGORY": 1.2,
        "MESSAGE_ID": "F1204",
        "MESSAGE_TEXT": "$님, 어제는 #보로 균형 잡힌 하루였어요.",
        "INTENSITY": "MID",
        "CONDITION": "5,000 ≤ 걸음수 < 9,000"
    },
    {
        "CATEGORY": 1.2,
        "MESSAGE_ID": "F1205",
        "MESSAGE_TEXT": "$님, 어제는 #보로 평소와 비슷한 활동량이었어요. 꾸준함이 체력을 만듭니다.",
        "INTENSITY": "MID",
        "CONDITION": "5,000 ≤ 걸음수 < 9,000"
    },
    {
        "CATEGORY": 1.2,
        "MESSAGE_ID": "F1206",
        "MESSAGE_TEXT": "$님, 어제는 #보로 적절한 활동량이었어요.",
        "INTENSITY": "MID",
        "CONDITION": "5,000 ≤ 걸음수 < 9,000"
    },
    {
        "CATEGORY": 1.2,
        "MESSAGE_ID": "F1207",
        "MESSAGE_TEXT": "$님, 어제는 #보로 무난한 하루를 보내셨어요. 체력이 안정적이에요.",
        "INTENSITY": "MID",
        "CONDITION": "5,000 ≤ 걸음수 < 9,000"
    },
    {
        "CATEGORY": 1.2,
        "MESSAGE_ID": "F1208",
        "MESSAGE_TEXT": "$님, 어제는 #보로 일정한 페이스를 유지했어요.",
        "INTENSITY": "MID",
        "CONDITION": "5,000 ≤ 걸음수 < 9,000"
    },
    {
        "CATEGORY": 1.2,
        "MESSAGE_ID": "F1209",
        "MESSAGE_TEXT": "$님, 어제는 #보로 평형감 있는 활동량이었어요.",
        "INTENSITY": "MID",
        "CONDITION": "5,000 ≤ 걸음수 < 9,000"
    },
    {
        "CATEGORY": 1.2,
        "MESSAGE_ID": "F1210",
        "MESSAGE_TEXT": "$님, 어제는 #보로 균형이 잘 잡힌 하루였어요.",
        "INTENSITY": "MID",
        "CONDITION": "5,000 ≤ 걸음수 < 9,000"
    },
    {
        "CATEGORY": 1.3,
        "MESSAGE_ID": "F1301",
        "MESSAGE_TEXT": "$님, 어제는 #보로 정말 활발하게 움직이셨어요! 대단해요.",
        "INTENSITY": "HIGH",
        "CONDITION": "걸음수 ≥ 9,000"
    },
    {
        "CATEGORY": 1.3,
        "MESSAGE_ID": "F1302",
        "MESSAGE_TEXT": "$님, 어제는 #보로 에너지가 넘쳤어요. 멋진 하루였네요.",
        "INTENSITY": "HIGH",
        "CONDITION": "걸음수 ≥ 9,000"
    },
    {
        "CATEGORY": 1.3,
        "MESSAGE_ID": "F1303",
        "MESSAGE_TEXT": "$님, 어제는 #보로 목표치를 달성했어요! 훌륭해요.",
        "INTENSITY": "HIGH",
        "CONDITION": "걸음수 ≥ 9,000"
    },
    {
        "CATEGORY": 1.3,
        "MESSAGE_ID": "F1304",
        "MESSAGE_TEXT": "$님, 어제는 #보로 강도 높은 하루였어요.",
        "INTENSITY": "HIGH",
        "CONDITION": "걸음수 ≥ 9,000"
    },
    {
        "CATEGORY": 1.3,
        "MESSAGE_ID": "F1305",
        "MESSAGE_TEXT": "$님, 어제는 #보로 체력이 향상된 게 느껴져요.",
        "INTENSITY": "HIGH",
        "CONDITION": "걸음수 ≥ 9,000"
    },
    {
        "CATEGORY": 1.3,
        "MESSAGE_ID": "F1306",
        "MESSAGE_TEXT": "$님, 어제는 #보로 활동량이 최고 수준이었어요.",
        "INTENSITY": "HIGH",
        "CONDITION": "걸음수 ≥ 9,000"
    },
    {
        "CATEGORY": 1.3,
        "MESSAGE_ID": "F1307",
        "MESSAGE_TEXT": "$님, 어제는 #보로 운동 감각이 완벽했어요.",
        "INTENSITY": "HIGH",
        "CONDITION": "걸음수 ≥ 9,000"
    },
    {
        "CATEGORY": 1.3,
        "MESSAGE_ID": "F1308",
        "MESSAGE_TEXT": "$님, 어제는 #보로 활기찬 하루를 보내셨네요.",
        "INTENSITY": "HIGH",
        "CONDITION": "걸음수 ≥ 9,000"
    },
    {
        "CATEGORY": 1.3,
        "MESSAGE_ID": "F1309",
        "MESSAGE_TEXT": "$님, 어제는 #보로 최상의 컨디션이었어요.",
        "INTENSITY": "HIGH",
        "CONDITION": "걸음수 ≥ 9,000"
    },
    {
        "CATEGORY": 1.3,
        "MESSAGE_ID": "F1310",
        "MESSAGE_TEXT": "$님, 어제는 #보로 정말 에너지가 넘쳤어요! 오늘은 조금 쉬어도 좋아요.",
        "INTENSITY": "HIGH",
        "CONDITION": "걸음수 ≥ 9,000"
    },
    {
        "CATEGORY": 1.4,
        "MESSAGE_ID": "F1401",
        "MESSAGE_TEXT": "$님, 평균 심박수는 &bpm으로 안정적인 하루였어요. 오늘은 몸을 조금 더 움직여볼까요?",
        "INTENSITY": "LOW",
        "CONDITION": "& < 75"
    },
    {
        "CATEGORY": 1.4,
        "MESSAGE_ID": "F1402",
        "MESSAGE_TEXT": "$님, 어제는 &bpm으로 비교적 조용한 하루였네요. 오늘은 가볍게 몸을 깨워봐요.",
        "INTENSITY": "LOW",
        "CONDITION": "& < 75"
    },
    {
        "CATEGORY": 1.4,
        "MESSAGE_ID": "F1403",
        "MESSAGE_TEXT": "$님, 평균 &bpm으로 여유 있는 하루를 보냈어요. 오늘은 조금 더 활기차게 걸어보아요.",
        "INTENSITY": "LOW",
        "CONDITION": "& < 75"
    },
    {
        "CATEGORY": 1.4,
        "MESSAGE_ID": "F1404",
        "MESSAGE_TEXT": "$님, 심박수 &bpm으로 컨디션이 안정적이에요. 오늘은 짧은 운동으로 리듬을 만들어봐요.",
        "INTENSITY": "LOW",
        "CONDITION": "& < 75"
    },
    {
        "CATEGORY": 1.4,
        "MESSAGE_ID": "F1405",
        "MESSAGE_TEXT": "$님, 어제의 평균 심박수는 &bpm이에요. 이제 몸이 쉬었으니 조금 더 활동해도 좋아요.",
        "INTENSITY": "LOW",
        "CONDITION": "& < 75"
    },
    {
        "CATEGORY": 1.4,
        "MESSAGE_ID": "F1406",
        "MESSAGE_TEXT": "$님, 평균 &bpm으로 편안한 하루였네요. 오늘은 가볍게 움직이며 활력을 더해봐요.",
        "INTENSITY": "LOW",
        "CONDITION": "& < 75"
    },
    {
        "CATEGORY": 1.4,
        "MESSAGE_ID": "F1407",
        "MESSAGE_TEXT": "$님, 심박수 &bpm으로 안정적인 리듬이었어요. 오늘은 조금 더 활발하게 움직여볼까요?",
        "INTENSITY": "LOW",
        "CONDITION": "& < 75"
    },
    {
        "CATEGORY": 1.4,
        "MESSAGE_ID": "F1408",
        "MESSAGE_TEXT": "$님, 어제는 몸이 충분히 회복된 하루였어요. 오늘은 조금 더 몸을 써보는 게 좋아요.",
        "INTENSITY": "LOW",
        "CONDITION": "& < 75"
    },
    {
        "CATEGORY": 1.4,
        "MESSAGE_ID": "F1409",
        "MESSAGE_TEXT": "$님, 평균 &bpm으로 조용히 에너지를 충전했어요. 오늘은 활동량을 늘려볼까요?",
        "INTENSITY": "LOW",
        "CONDITION": "& < 75"
    },
    {
        "CATEGORY": 1.4,
        "MESSAGE_ID": "F1410",
        "MESSAGE_TEXT": "$님, 심박수 &bpm으로 편안한 하루였네요. 오늘은 리듬을 높여 에너지를 채워봐요.",
        "INTENSITY": "LOW",
        "CONDITION": "& < 75"
    },
    {
        "CATEGORY": 1.5,
        "MESSAGE_ID": "F1501",
        "MESSAGE_TEXT": "$님, 평균 심박수는 &bpm으로 적당한 활동을 하셨네요. 오늘도 그 리듬을 이어가요.",
        "INTENSITY": "MID",
        "CONDITION": "75 ≤ & < 80"
    },
    {
        "CATEGORY": 1.5,
        "MESSAGE_ID": "F1502",
        "MESSAGE_TEXT": "$님, 어제는 &bpm으로 활기찬 하루였어요. 오늘도 비슷한 페이스로 가볼까요?",
        "INTENSITY": "MID",
        "CONDITION": "75 ≤ & < 80"
    },
    {
        "CATEGORY": 1.5,
        "MESSAGE_ID": "F1503",
        "MESSAGE_TEXT": "$님, 평균 &bpm으로 좋은 움직임을 보여주셨어요. 오늘도 꾸준히 이어가봐요.",
        "INTENSITY": "MID",
        "CONDITION": "75 ≤ & < 80"
    },
    {
        "CATEGORY": 1.5,
        "MESSAGE_ID": "F1504",
        "MESSAGE_TEXT": "$님, 심박수 &bpm으로 체력이 안정적으로 유지되고 있어요. 오늘도 자신 있게 나아가요.",
        "INTENSITY": "MID",
        "CONDITION": "75 ≤ & < 80"
    },
    {
        "CATEGORY": 1.5,
        "MESSAGE_ID": "F1505",
        "MESSAGE_TEXT": "$님, 어제는 평균 &bpm으로 활발했어요. 오늘은 조금 더 도전해봐도 좋겠어요.",
        "INTENSITY": "MID",
        "CONDITION": "75 ≤ & < 80"
    },
    {
        "CATEGORY": 1.5,
        "MESSAGE_ID": "F1506",
        "MESSAGE_TEXT": "$님, 심박수 &bpm으로 활동량이 적당했어요. 오늘은 유연성 운동을 더해볼까요?",
        "INTENSITY": "MID",
        "CONDITION": "75 ≤ & < 80"
    },
    {
        "CATEGORY": 1.5,
        "MESSAGE_ID": "F1507",
        "MESSAGE_TEXT": "$님, 어제는 &bpm으로 몸이 잘 반응했어요. 오늘도 꾸준히 리듬을 유지해요.",
        "INTENSITY": "MID",
        "CONDITION": "75 ≤ & < 80"
    },
    {
        "CATEGORY": 1.5,
        "MESSAGE_ID": "F1508",
        "MESSAGE_TEXT": "$님, 평균 &bpm으로 하루 종일 활기찼어요. 오늘은 강도보단 지속이 좋아요.",
        "INTENSITY": "MID",
        "CONDITION": "75 ≤ & < 80"
    },
    {
        "CATEGORY": 1.5,
        "MESSAGE_ID": "F1509",
        "MESSAGE_TEXT": "$님, 어제의 심박수는 &bpm이었어요. 활동량이 좋았어요! 오늘은 스트레칭으로 마무리해요.",
        "INTENSITY": "MID",
        "CONDITION": "75 ≤ & < 80"
    },
    {
        "CATEGORY": 1.5,
        "MESSAGE_ID": "F1510",
        "MESSAGE_TEXT": "$님, 평균 &bpm으로 이상적인 활동량이에요. 오늘도 즐겁게 움직여요.",
        "INTENSITY": "MID",
        "CONDITION": "75 ≤ & < 80"
    },
    {
        "CATEGORY": 1.6,
        "MESSAGE_ID": "F1601",
        "MESSAGE_TEXT": "$님, 평균 심박수는 &bpm으로 활발한 하루를 보냈네요. 오늘은 몸을 조금 쉬게 해주세요.",
        "INTENSITY": "HIGH",
        "CONDITION": "& ≥ 80"
    },
    {
        "CATEGORY": 1.6,
        "MESSAGE_ID": "F1602",
        "MESSAGE_TEXT": "$님, 어제는 &bpm으로 신체 활동이 많았어요. 오늘은 회복을 위한 시간을 가져요.",
        "INTENSITY": "HIGH",
        "CONDITION": "& ≥ 80"
    },
    {
        "CATEGORY": 1.6,
        "MESSAGE_ID": "F1603",
        "MESSAGE_TEXT": "$님, 평균 &bpm으로 활발하게 움직이셨네요. 오늘은 가벼운 스트레칭으로 마무리해요.",
        "INTENSITY": "HIGH",
        "CONDITION": "& ≥ 80"
    },
    {
        "CATEGORY": 1.6,
        "MESSAGE_ID": "F1604",
        "MESSAGE_TEXT": "$님, 어제의 심박수는 &bpm이에요. 몸이 수고했어요. 오늘은 천천히 회복해요.",
        "INTENSITY": "HIGH",
        "CONDITION": "& ≥ 80"
    },
    {
        "CATEGORY": 1.6,
        "MESSAGE_ID": "F1605",
        "MESSAGE_TEXT": "$님, 심박수 &bpm으로 활동량이 높았어요. 오늘은 휴식으로 에너지를 다시 채워봐요.",
        "INTENSITY": "HIGH",
        "CONDITION": "& ≥ 80"
    },
    {
        "CATEGORY": 1.6,
        "MESSAGE_ID": "F1606",
        "MESSAGE_TEXT": "$님, 평균 &bpm으로 활기찬 하루였어요. 오늘은 몸의 피로를 풀어주세요.",
        "INTENSITY": "HIGH",
        "CONDITION": "& ≥ 80"
    },
    {
        "CATEGORY": 1.6,
        "MESSAGE_ID": "F1607",
        "MESSAGE_TEXT": "$님, 어제는 많이 움직이셨네요! 심박수 &bpm으로 오늘은 회복이 필요해요.",
        "INTENSITY": "HIGH",
        "CONDITION": "& ≥ 80"
    },
    {
        "CATEGORY": 1.6,
        "MESSAGE_ID": "F1608",
        "MESSAGE_TEXT": "$님, 평균 &bpm으로 몸이 꽤 바빴던 하루였어요. 오늘은 조금 쉬어가요.",
        "INTENSITY": "HIGH",
        "CONDITION": "& ≥ 80"
    },
    {
        "CATEGORY": 1.6,
        "MESSAGE_ID": "F1609",
        "MESSAGE_TEXT": "$님, 심박수 &bpm으로 컨디션이 높았어요. 오늘은 낮은 강도의 운동으로 이어가요.",
        "INTENSITY": "HIGH",
        "CONDITION": "& ≥ 80"
    },
    {
        "CATEGORY": 1.6,
        "MESSAGE_ID": "F1610",
        "MESSAGE_TEXT": "$님, 어제는 정말 활발했어요! 평균 &bpm으로 오늘은 휴식이 어울려요.",
        "INTENSITY": "HIGH",
        "CONDITION": "& ≥ 80"
    }
]